/** @jsx jsx */
import { HistoryChart } from '@charts';
import { ChartContextWrapper } from 'src/components/composite/chart-generator/shared';
import { ProtectedRouteAndRedirect } from 'src/components/composite/ProtectedRoute';
import { jsx } from 'theme-ui';

export default function () {
  return (
    <ChartContextWrapper>
      <ProtectedRouteAndRedirect path='/' component={HistoryChart} />
    </ChartContextWrapper>
  );
}
